import React from 'react';
import Header from '../components/Header/Header';

const BlogPage = () => {
  return (
    <>
      <Header />
      <section className="blog">
        <h1>Blog</h1>
        <p>Entradas del blog...</p>
      </section>
    </>
  );
};

export default BlogPage;
